export const PATHS = {
	ROOT: '/',
	DASHBOARD: '/dashboard',
	DASHBOARD_PRODUCT: '/dashboard/product',
	DASHBOARD_FORMATION: '/dashboard/formation',
	DASHBOARD_CLIENT_BILLING: '/dashboard/client-billing',
	DASHBOARD_SUPPLIER_BILLING: '/dashboard/supplier-billing',
	DASHBOARD_TRAINER_RESUME: '/dashboard/trainer-resume',
	DASHBOARD_COMPANY_BILLING: '/dashboard/company-billing',
	DASHBOARD_TRAINING_BILLING: '/dashboard/training-billing',
	SEARCHES_ONLY: '/searches',
	SEARCHES_STUDENTS: '/searches/students',
	LOGIN: '/login',
	CLIENT: '/client-suppler/client',
	CLIENT_ONLY: '/client-suppler',
	PRODUCTS_SERVICES_ONLY: '/products-and-services',
	FORMATIONS_ONLY: '/trainings-trainers',
	ACCOUNTING_ONLY: '/accounting',
	NOTEBOOK_ONLY: '/notebook',
	CLIENT_DEFIBRILLATOR: '/defibrillator',
	CLIENT_BUDGET: '/budget',
	CLIENT_FORMATION: '/formation',
	CLIENT_INVOICE: '/invoice',
	CLIENT_FOLLOW: '/follow-up',
	INFORMATION: '/information',
	SUPPLIER: '/client-suppler/supplier',
	SUPPLIER_INFORMATION: '/information',
	SUPPLIER_PRODUCTS: '/product',
	SUPPLIER_INVOICE: '/invoice',
	SUPPLIER_FOLLOW: '/follow-up',
	SUBCONTRACT: '/client-suppler/subcontract',
	SUBCONTRACT_INFORMATION: '/information',
	SUBCONTRACT_CLIENT: '/client',
	SUBCONTRACT_COURSE: '/course',
	SUBCONTRACT_INVOICE: '/invoice',
	SUBCONTRACT_BUDGET: '/budget',
	SUBCONTRACT_FOLLOW: '/follow-up',
	SUBCONTRACT_DOCUMENTS: '/files',
	PRODUCTS_AND_SERVICES: '/products-and-services',
	DEFIBRILLATOR: '/products-and-services/defibrillator',
	DEFIBRILLATOR_INFORMATION: '/information',
	DEFIBRILLATOR_FOLLOW: '/follow-up',
	DEFIBRILLATOR_REVIEW: '/review',
	DEFIBRILLATOR_NOTE: '/note',
	PRODUCT: '/products-and-services/product',
	KIT: '/products-and-services/kit',
	KIT_INFORMATION: '/information',
	KIT_HISTORY: '/history',
	FORMATION: '/trainings-trainers/formation',
	FORMATION_INFORMATION: '/information',
	FORMATION_ENROLL: '/enroll',
	FORMATION_NOTE: '/note',
	FORMATION_BILL: '/bill',
	FORMATION_FOLLOW: '/follow-up',
	FORMATION_FILE: '/file',
	TRAINER: '/trainings-trainers/trainer',
	TRAINER_INFORMATION: '/information',
	TRAINER_COURSE: '/course',
	TRAINER_NOTE: '/note',
	TRAINER_KIT: '/kit',
	TRAINER_PROVINCE: '/province',
	TRAINER_FOLLOW: '/follow-up',
	TRAINER_FILE: '/file',
	TYPES_FORMATION: '/trainings-trainers/type',
	TYPES_FORMATION_COMMUNITY: '/community',
	TYPES_FORMATION_COMMUNITY_DETAIL: '/community/detail',
	TYPES_FORMATION_SIMPLE_DETAIL: '/simple-detail',
	ACCOUNTING: '/accounting',
	BUDGET: '/accounting/budget',
	BUDGET_CREATE: '/create',
	BUDGET_EDIT: '/edit',
	BUDGET_DETAIL: '/detail',
	BUDGET_FOLLOW_UP: '/follow-up',
	INVOICE: '/accounting/invoice',
	INVOICE_CREATE: '/create',
	INVOICE_EDIT: '/edit',
	INVOICE_DETAIL: '/detail',
	INVOICE_FOLLOW_UP: '/follow-up',
	BILL: '/accounting/bill',
	BILL_CREATE: '/create',
	BILL_EDIT: '/edit',
	BILL_DETAIL: '/detail',
	BILL_FOLLOW_UP: '/follow-up',
	BILL_TRAINER: '/accounting/trainer-bill',
	BILL_TRAINER_CREATE: '/create',
	BILL_TRAINER_EDIT: '/edit',
	BILL_TRAINER_DETAIL: '/detail',
	BILL_TRAINER_FOLLOW_UP: '/follow-up',
	NOTEBOOK: '/notebook',
	SETTINGS_COMPANY_MANAGMENT: '/company-managment',
	SETTINGS_COMPANY_MANAGMENT_COMPANY_DATA: '/company-managment/company-data',
	SETTINGS_COMPANY_MANAGMENT_COMPANY_DATA_DETAIL: '/details',
	SETTINGS_COMPANY_MANAGMENT_COMPANY_DATA_FILES: '/files',
	SETTINGS_COMPANY_MANAGMENT_BONUS_COMPANY: '/company-managment/bonus-company',
	SETTINGS_USER_ROLE: '/user-role',
	SETTINGS_USER_ROLE_USER: '/user-role/user',
	SETTINGS_USER_ROLE_ROLE: '/user-role/role',
	SETTINGS_USER_ROLE_ACCESS_HISTORY: '/user-role/access-history',
	SETTINGS_GENERAL_DATA: '/general-data/legal-data',
	SETTINGS_LEGAL_DATA_LOPD: '/general-data/legal-data/lopd',
	SETTINGS_LEGAL_DATA_VAT: '/general-data/legal-data/vat',
	SETTINGS_LEGAL_DATA_COUNTER_DOCUMENT: '/general-data/legal-data/counter-document',
	SETTINGS_LEGAL_DATA_COUNTER_DOCUMENT_BUDGET: '/budget',
	SETTINGS_LEGAL_DATA_COUNTER_DOCUMENT_INVOICED: '/invoiced',
	SETTINGS_LEGAL_DATA_COUNTER_DOCUMENT_FORMATION: '/formation',
	SETTINGS_LEGAL_DATA_COUNTER_DOCUMENT_DIPLOMA: '/diploma',
	SETTINGS_LEGAL_DATA_COUNTER_DOCUMENT_MATERIAL: '/material',
	SEETINGS_GENERAL_DATA_FOLDABLE: '/general-data/foldable',
	SEETINGS_GENERAL_DATA_FOLDABLE_BRAND_DEFIBRILLATOR: '/general-data/foldable/brand-defibrilator',
	SEETINGS_GENERAL_DATA_FOLDABLE_SECTOR: '/general-data/foldable/sector',
	SEETINGS_GENERAL_DATA_FOLDABLE_FAMILY: '/general-data/foldable/family',
	SEETINGS_GENERAL_DATA_FOLDABLE_PAYMENT_CONDITION: '/general-data/foldable/payment-condition',
	SETTINGS_TECHNICAL_DATA: '/technical-data',
	SETTINGS_TECHNICAL_DATA_GOOGLE_CALENDAR: '/technical-data/google-calendar',
	SETTINGS_TECHNICAL_DATA_SERVER: '/technical-data/server',
	PORTAL_SUBCONTRACT: '/portal/subcontrata',
	PORTAL_SUBCONTRACT_RESUME: '/portal/subcontrata/resumen',
	PORTAL_SUBCONTRACT_CLIENTS: '/portal/subcontrata/clientes',
	PORTAL_SUBCONTRACT_FORMATIONS: '/portal/subcontrata/formaciones',
	PORTAL_SUBCONTRACT_DEFIBRILLATORS: '/portal/subcontrata/desfibriladores',
	PORTAL_CLIENT: '/portal/cliente',
	PORTAL_CLIENT_RESUME: '/portal/cliente/resumen',
	PORTAL_CLIENT_FORMATIONS: '/portal/cliente/formaciones',
	PORTAL_CLIENT_DEFIBRILLATORS: '/portal/cliente/desfibriladores',
	PORTAL_TRAINER: '/portal/formador',
	PORTAL_TRAINER_CALENDAR: '/portal/formador/calendario',
	PORTAL_TRAINER_FORMATION_DETAIL: '/portal/formador/formaciones/:formationId',
	ACCOUNT: '/account',
	ACCOUNT_PROFILE: '/profile',
	FOLLOW: '/follow-up',
	PROFILE: '/profile',
};
